import { createAvatar } from '@dicebear/core';
import * as initialsAvatar from '@dicebear/initials';
import { type ComponentProps, type FC, useMemo } from 'react';
import { cn } from './react';

export const Avatar: FC<
  {
    seed?: string;
  } & Omit<ComponentProps<'img'>, 'src' | 'srcSet'>
> = ({ seed, alt, className, ...imgProps }) => {
  const avatar = useMemo(() => {
    if (!seed)
      return createAvatar(initialsAvatar, {
        backgroundColor: ['F2F2F2'],
      }).toDataUri();
    return createAvatar(initialsAvatar, {
      seed,
      fontWeight: 700,
      fontSize: 48,
    }).toDataUri();
  }, [seed]);
  return (
    <img
      src={avatar ?? ''}
      alt={alt ?? seed}
      className={cn(
        className,
        'rounded-full',
        'outline-2 -outline-offset-2 outline-shades-black-5',
      )}
      {...imgProps}
    />
  );
};
